import {makeStyles, Text, tokens} from "@fluentui/react-components";
import * as React from "react";
import {useMemo} from "react";

interface EmailPreviewProps {
    subject?: string | null;
    content: string;
    maxHeight: string;
}

const useStyles = makeStyles({
    preview: {
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusLarge,
        padding: tokens.spacingVerticalM,
    },
    previewSubject: {
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: tokens.spacingVerticalS,
        display: "block",
        color: tokens.colorNeutralForeground1,
    },
    frame: {
        width: "100%",
        border: "none",
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: "#ffffff",
        display: "block",
        colorScheme: "light",
    },
});

// Wrap the Outlook HTML in a minimal document with an explicit light scheme.
// Outlook HTML is authored for a white email client — we render it that way
// regardless of the surrounding Fluent theme so dark text stays readable.
function wrapEmailHtml(html: string): string {
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
</head>
<body>${html}</body>
</html>`;
}

export default function EmailPreview(props: Readonly<EmailPreviewProps>) {
    const styles = useStyles();
    const srcDoc = useMemo(() => wrapEmailHtml(props.content), [props.content]);

    return (
        <div className={styles.preview}>
            {props.subject && <Text className={styles.previewSubject}>{props.subject}</Text>}
            <iframe
                title="Email preview"
                srcDoc={srcDoc}
                sandbox=""
                className={styles.frame}
                style={{height: props.maxHeight}}
            />
        </div>
    );
}